import React from 'react';
import { Link } from 'react-router-dom';
import './RelatedPulseLinks.css';
import { getPulsePath } from './relatedPulseArticles';

const RelatedPulseLinks = ({ articles, links = [], label = 'From ShuttleOps Pulse' }) => (
  <aside className="related-pulse-links" aria-label="Related ShuttleOps pages">
    <span className="related-pulse-links__label">{label}</span>
    <ul className="related-pulse-links__list">
      {articles.map((article) => (
        <li key={article.slug}>
          <Link className="related-pulse-links__link" to={getPulsePath(article.slug)}>
            {article.title}
            <span aria-hidden="true"> →</span>
          </Link>
        </li>
      ))}
      {links.map((link) => (
        <li key={link.path}>
          <Link className="related-pulse-links__link" to={link.path}>
            {link.title}
            <span aria-hidden="true"> →</span>
          </Link>
        </li>
      ))}
    </ul>
  </aside>
);

export default RelatedPulseLinks;
